import { DetailBadge } from "@/features/ui/detail/DetailBadge";
import { DetailContent } from "@/features/ui/detail/DetailContent";
import { DetailField } from "@/features/ui/detail/DetailField";
import { DetailHeader } from "@/features/ui/detail/DetailHeader";
import { DetailInformTitle } from "@/features/ui/detail/DetailInformTitle";
import { DetailLabel } from "@/features/ui/detail/DetailLabel";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { DetailLinkWrapper } from "@/features/ui/detail/DetailLinkWrapper";
import { DetailTitle } from "@/features/ui/detail/DetailTitle";
import DatetimeUtil from "@/utils/dateTimeUtil";
import { Space } from "@mantine/core";
import {
  VehiclesGet200Response,
  VehiclesGet200ResponseRowsInner,
} from "@sizlcorp/sizl-api-document/dist/models";
import { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";

const DetailVehicle = Object.assign(DetailHeader, {
  Title: DetailTitle,
  Inform: DetailInformTitle,
  Field: DetailField,
  Label: DetailLabel,
  Link: DetailLink,
  LinkWrapper: DetailLinkWrapper,
  Badge: DetailBadge,
  Content: DetailContent,
});

interface VehicleDetailHeaderProps {
  data?: AxiosResponse<VehiclesGet200Response, any> | undefined;
}
export const VehicleDetailHeader = (params: VehicleDetailHeaderProps) => {
  const { data } = params;
  const { t } = useTranslation();
  const vehicle = data?.data?.rows && (data?.data?.rows as VehiclesGet200ResponseRowsInner[])[0];

  return (
    <DetailVehicle>
      <DetailVehicle.Title>
        {`[${t("common.detail", { item: t("vehicle.vehicle") })}]`}
      </DetailVehicle.Title>
      <Space h={8} />
      <DetailVehicle.Field>
        <DetailVehicle.Label>{t("vehicle.name")}</DetailVehicle.Label>
        <DetailVehicle.Content>{vehicle?.name}</DetailVehicle.Content>
      </DetailVehicle.Field>
      <DetailVehicle.Field>
        <DetailVehicle.Label>{t("vehicle.code")}</DetailVehicle.Label>
        <DetailVehicle.Content>{vehicle?.code}</DetailVehicle.Content>
      </DetailVehicle.Field>
      <DetailVehicle.Field>
        <DetailVehicle.Label>{t("vehicle.plateNumber")}</DetailVehicle.Label>
        <DetailVehicle.Content>{vehicle?.plateNumber}</DetailVehicle.Content>
      </DetailVehicle.Field>
      <DetailVehicle.Field>
        <DetailVehicle.Label>{t("vehicle.driver")}</DetailVehicle.Label>
        <DetailVehicle.Content>{vehicle?.driver}</DetailVehicle.Content>
      </DetailVehicle.Field>
      <DetailVehicle.Field>
        <DetailVehicle.Label>{t("vehicle.description")}</DetailVehicle.Label>
        <DetailVehicle.Content>{vehicle?.description}</DetailVehicle.Content>
      </DetailVehicle.Field>
      <DetailVehicle.Field>
        <DetailVehicle.Label>
          {t("info.creatorUserCode")} ({t("info.createdAt")})
        </DetailVehicle.Label>
        <DetailVehicle.Content>
          {" "}
          {vehicle?.creatorUserCode} ({vehicle?.createdAt ? DatetimeUtil(vehicle?.createdAt) : ""})
        </DetailVehicle.Content>
      </DetailVehicle.Field>
    </DetailVehicle>
  );
};
